var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatar1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 52,
    viewBox: "0 0 51 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2053_61)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.663086,
    width: 50.7429,
    height: 50.7429,
    rx: 25.3715,
    fill: "#EDD75A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.2227,
    y: 9.12012,
    width: 20.2972,
    height: 20.2972,
    rx: 10.1486,
    fill: "#73B06F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -12.6855,
    y: 34.4917,
    width: 76.1144,
    height: 76.1144,
    rx: 38.0572,
    fill: "#73B06F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2053_61"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.663086,
    width: 50.7429,
    height: 50.7429,
    rx: 25.3715,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar1);
export default __webpack_public_path__ + "static/media/avatar1.f6a8f27d8fed2f5c256fce6056a6e433.svg";
export { ForwardRef as ReactComponent };